import { render, staticRenderFns } from "./AboutSubject.vue?vue&type=template&id=5071f021&scoped=true"
import script from "./AboutSubject.vue?vue&type=script&lang=ts"
export * from "./AboutSubject.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5071f021",
  null
  
)

export default component.exports